import { DomSanitizer } from '@angular/platform-browser';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';
import { ApiModule } from '../api/api.module';
import { ModelCacheModule } from '../model-cache/model-cache.module';
import { ModeModelAngularJsMigrationAdapter, ModeModelInjectables } from './model';
import { ModeCollectionFactoryService, modeCollectionFactoryAngularMigrationAdapter } from './model-collection.factory';
import { ModelNameService } from './model-name.service';
import { ModelAccessorAngularJsMigrationAdapter, ModelAccessorInjectables } from './model_accessor';
import * as Models from './models';

const modeModelModule = angular.module('mode.model', [
  ApiModule,
  ModelCacheModule,
  'mode.common.constants',
  'mode.assets',
]);

modeModelModule
  .factory('ModeModel', ModeModelAngularJsMigrationAdapter)
  .service('ModeModelInjectables', downgradeInjectable(ModeModelInjectables))
  .service('ModelAccessorInjectables', downgradeInjectable(ModelAccessorInjectables))
  .service('ModeCollectionFactory', downgradeInjectable(ModeCollectionFactoryService))
  .service('ModeCollection', modeCollectionFactoryAngularMigrationAdapter)
  .factory('ModeModelAccessor', ModelAccessorAngularJsMigrationAdapter)
  .service('ModelNameService', downgradeInjectable(ModelNameService));

// Provide replacement for '$sce'
modeModelModule.service('DomSanitizer', downgradeInjectable(DomSanitizer));
modeModelModule
  .service('AccountModel', downgradeInjectable(Models.AccountModelAccessor))
  .service('ApiModel', downgradeInjectable(Models.ApiModelAccessor))
  .service('ChannelModel', downgradeInjectable(Models.ChannelModelAccessor))
  .service('ChartModel', downgradeInjectable(Models.ChartModelAccessor))
  .service('ColorPaletteModel', downgradeInjectable(Models.ColorPaletteModelAccessor))
  .service('DataSourceSchemaUpdateModel', downgradeInjectable(Models.DataSourceSchemaUpdateModelAccessor))
  .service('DataSourceTableModel', downgradeInjectable(Models.DataSourceTableModelAccessor))
  .service('DataSourceModel', downgradeInjectable(Models.DataSourceModelAccessor))
  .service('EmailSubscriptionMembershipModel', downgradeInjectable(Models.EmailSubscriptionMembershipModelAccessor))
  .service('EmbedKeyModel', downgradeInjectable(Models.EmbedKeyModelAccessor))
  .service('ExplorationModel', downgradeInjectable(Models.ExplorationModelAccessor))
  .service('GroupMembershipModel', downgradeInjectable(Models.GroupMembershipModelAccessor))
  .service('GroupModel', downgradeInjectable(Models.GroupModelAccessor))
  .service('InviteModel', downgradeInjectable(Models.InviteModelAccessor))
  .service('LibraryDefinitionModel', downgradeInjectable(Models.LibraryDefinitionModelAccessor))
  .service('OrgModel', downgradeInjectable(Models.OrgModelAccessor))
  .service('PdfExportModel', downgradeInjectable(Models.PdfExportModelAccessor))
  .service('PinModel', downgradeInjectable(Models.PinModelAccessor))
  .service('PreferenceModel', downgradeInjectable(Models.PreferenceModelAccessor))
  .service('PythonCellBatchRunModel', downgradeInjectable(Models.PythonCellBatchRunModelAccessor))
  .service('PythonCellRunResultModel', downgradeInjectable(Models.PythonCellRunResultModelAccessor))
  .service('PythonCellRunModel', downgradeInjectable(Models.PythonCellRunModelAccessor))
  .service('PythonCellModel', downgradeInjectable(Models.PythonCellModelAccessor))
  .service('PythonNotebookModel', downgradeInjectable(Models.PythonNotebookModelAccessor))
  .service('PythonSessionModel', downgradeInjectable(Models.PythonSessionModelAccessor))
  .service('PythonVisualizationModel', downgradeInjectable(Models.PythonVisualizationModelAccessor))
  .service('QueryRunModel', downgradeInjectable(Models.QueryRunModelAccessor))
  .service('QueryTableModel', downgradeInjectable(Models.QueryTableModelAccessor))
  .service('QueryModel', downgradeInjectable(Models.QueryModelAccessor))
  .service('ReportFilterModel', downgradeInjectable(Models.ReportFilterModelAccessor))
  .service('ReportPinModel', downgradeInjectable(Models.ReportPinModelAccessor))
  .service('ReportRunEmailModel', downgradeInjectable(Models.ReportRunEmailModelAccessor))
  .service('ReportRunSlackMessageModel', downgradeInjectable(Models.ReportRunSlackMessageModelAccessor))
  .service('ReportRunModel', downgradeInjectable(Models.ReportRunModelAccessor))
  .service('ReportScheduleModel', downgradeInjectable(Models.ReportScheduleModelAccessor))
  .service('ReportSubscriptionModel', downgradeInjectable(Models.ReportSubscriptionModelAccessor))
  .service('ReportThemeModel', downgradeInjectable(Models.ReportThemeModelAccessor))
  .service('ReportModel', downgradeInjectable(Models.ReportModelAccessor))
  .service('ResultModel', downgradeInjectable(Models.ResultModelAccessor))
  .service('SearchModel', downgradeInjectable(Models.SearchModelAccessor))
  .service('SlackAppModel', downgradeInjectable(Models.SlackAppModelAccessor))
  .service('SlackSubscriptionMembershipModel', downgradeInjectable(Models.SlackSubscriptionMembershipModelAccessor))
  .service('SpaceDetailModel', downgradeInjectable(Models.SpaceDetailModelAccessor))
  .service('SpaceLinkModel', downgradeInjectable(Models.SpaceLinkModelAccessor))
  .service('SpaceMembershipModel', downgradeInjectable(Models.SpaceMembershipModelAccessor))
  .service('SpaceReportPinModel', downgradeInjectable(Models.SpaceReportPinModelAccessor))
  .service('SpaceModel', downgradeInjectable(Models.SpaceModelAccessor))
  .service('StarModel', downgradeInjectable(Models.StarModelAccessor))
  .service('TablePreviewModel', downgradeInjectable(Models.TablePreviewModelAccessor))
  .service('TableValidationModel', downgradeInjectable(Models.TableValidationModelAccessor))
  .service('TableModel', downgradeInjectable(Models.TableModelAccessor));

export const ModelModule = modeModelModule.constant('lodash', _).constant('$', $).name;
